import { APP_NAME, $html } from '../utils/environment';
import AbstractModule from './AbstractModule';

const MODULE_NAME = 'Search';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

const EVENT = {
    CLICK: `click.${EVENT_NAMESPACE}`
};

export default class extends AbstractModule {
    constructor(options) {
        super(options);
    }

    init() {
        this.$el.on(EVENT.CLICK, '.js-search-toggle', (event) => this.toggleSearch());
        this.$el.on(EVENT.CLICK, '.c-search_quick_item', (event) => this.toggleSearch());

        const that = this;
        $('.c-search_input-wrap').submit(function() {
            that.toggleSearch();
        });
    }

    toggleSearch() {
        const $input = this.$el.find('.js-search-input');

        if ($html.hasClass('has-search-open')) {
            $html.removeClass('has-search-open');
            $input.blur();
        } else {
            $html.addClass('has-search-open');
            $input.focus();
        }
    }

    destroy() {
        super.destroy();
        this.$el.off(`.${EVENT_NAMESPACE}`);
    }
}
